<template>
	<div class="box">
		<div class="row">
			<div class="col-12">
	            <DateRangeV2
	                :start.sync="start_date"
	                :end.sync="end_date"
	                :dateSelect="true"
	                :periodToShow="['personalise','jour','mois','mois_dernier']"
					@submit="init_component"
	            />
			</div>
			<div class="col-12">
				<CustomTable
		            id_table="stock_import"
		            ref="table"
		            :items="lots"
		            :busy.sync="table_busy"
		            primaryKey="semencelot_id"
		            :hide_if_empty="true"
		            :hrefsRoutes="config_table_hrefs"
					:externSlotColumns="['couleur']"
		        >
					<template v-slot:custom-slot-cell(couleur)="{ data }">
						<span v-if="data.couleur">{{ $t('monte.couleur.' + data.couleur.semencecouleur_code) }}</span>
					</template>
				</CustomTable>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import Congelation from "@/mixins/Congelation.js"

	export default {
		name: 'StockImport',
		mixins: [Congelation],
		data () {
			return {
				table_busy: false,
				lots: [],
				start_date: new Date(new Date().setMonth(new Date().getMonth() - 1)),
				end_date: new Date(new Date().setMonth(new Date().getMonth())),
				config_table_hrefs: {
					'horse.horse_nom': {
						routeUniqueName: 'horseFiche',
						routeName: 'horseFiche',
						params: {
							horse_id: 'horse.horse_id'
						}
					},
					'first_emplacement.from_tiers.tiers_rs': {
						routeUniqueName: 'tiersTableauBord',
						routeName: 'tiersTableauBord',
						params: {
							tiers_id: 'first_emplacement.from_tiers.tiers_id'
						}
					},
				}
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				this.table_busy = true
				this.lots = await this.getStockImport(this.start_date, this.end_date)
				this.table_busy = false
			},
		},

		components: {
			CustomTable : () => import('GroomyRoot/components/Table/CustomTable'),
			DateRangeV2: () => import('GroomyRoot/components/Inputs/DateRangeV2')
		}
	}

</script>